import { getApi, postApi } from "./api_instance";

export const getTaxationCharges = async (logout = () => {}) => {
  try {
    const { data, success = false } = await getApi({
      apiUrl: `/admin/projects/api/taxation/charges`,
      sendToken: true,
      logout,
    });
    if (success) {
      return data;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};

export const updateTaxationCharges = async (requestBody, logout = () => {}) => {
  try {
    const { data, success = false } = await postApi({
      apiUrl: `/admin/projects/api/taxation//save`,
      sendToken: true,
      data: requestBody,
      logout,
    });
    if (success) {
      return data;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};
